export default "__VITE_ASSET__CzSv7PsX__"